<div>
  <gpf-checkbox-list
    [title]="'Present in Child'"
    [items]="presentInChildValues"
    [selectedItems]="selectedValues"
    (itemsUpdateEvent)="updatePresentInChild($event)">
  </gpf-checkbox-list>
  <gpf-errors-alert [errors]="errors"></gpf-errors-alert>

  <gpf-zygosity-filter *ngIf="hasZygosity" [parentComponent]="'presentInChild'"></gpf-zygosity-filter>
</div>
